/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KioskConfigDto } from '../../models/kiosk-config-dto';

export interface KioskConfigControllerActivateV1$Params {
  sourceType: string;
}

export function kioskConfigControllerActivateV1(http: HttpClient, rootUrl: string, params: KioskConfigControllerActivateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<KioskConfigDto>> {
  const rb = new RequestBuilder(rootUrl, kioskConfigControllerActivateV1.PATH, 'put');
  if (params) {
    rb.path('sourceType', params.sourceType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KioskConfigDto>;
    })
  );
}

kioskConfigControllerActivateV1.PATH = '/api/v1/kiosk-config/{sourceType}/activate';
